import { CardProvider } from 'context/cards/cardContext';
import OverviewSection from '../components/OverviewSection/OverviewSection';

export const OverViewPage = () => {
    return (
        <CardProvider>
            <OverviewSection />
        </CardProvider>
    );
};
